$(document).ready(function() {
    
    // Define the SVG markup
    var svgMarkup = `
        <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
            <defs>
                <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"></path>
            </defs>
            <g class="parallax">
                <use xlink:href="#gentle-wave" x="48" y="0" fill="" style="
    fill: rgba(var(--color-scheme-background),var(--tw-bg-opacity));
"></use>
            </g>
        </svg>
    `;

    // Append the SVG markup to the specified div
    $('.ts-wave-animate').append(svgMarkup);
});



  (function () {
    const BUNDLE_KEY = "_rc_bundle";

    function getBundleIdFromItem(item) {
      if (!item || !item.properties) return null;

      const prop = item.properties[BUNDLE_KEY];
      if (!prop) return null;

      if (typeof prop === "object" && prop !== null) {
        // Recharge often stores { id: "..." }
        return prop.id || JSON.stringify(prop);
      }

      return String(prop);
    }

    async function fetchCart() {
      const res = await fetch("/cart.js", {
        method: "GET",
        headers: {
          "Accept": "application/json"
        }
      });
      if (!res.ok) throw new Error("Failed to load cart.js");
      return res.json();
    }

    // Remove all items in the bundle EXCEPT the clicked one.
    async function removeOtherBundleItems(bundleId, clickedItemKey) {
      if (!bundleId) return;

      const cart = await fetchCart();

      const itemsToRemove = cart.items.filter((item) => {
        const itemBundleId = getBundleIdFromItem(item);
        return (
          itemBundleId === bundleId &&
          item.key !== clickedItemKey // 👈 skip the clicked line, Rebuy handles it
        );
      });

      console.log("Bundle id:", bundleId);
      console.log("Clicked item key:", clickedItemKey);
      console.log(
        "Other bundle items to remove:",
        itemsToRemove.map((i) => ({ key: i.key, title: i.product_title }))
      );

      // Use line-item key in /cart/change.js to avoid line index issues
      for (const item of itemsToRemove) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: item.key,      // 👈 stable line item key
            quantity: 0
          })
        });
      }

      // Optionally: refresh UI if Rebuy doesn't auto-sync
      // window.location.reload();
    }

    // Listener: do NOT prevent default, let Rebuy handle its own click
    document.addEventListener("click", function (event) {
      const btn = event.target.closest(".js-bundle-remove");
      if (!btn) return;

      const bundleId = btn.getAttribute("data-bundle-id");
      const itemKey = btn.getAttribute("data-item-key");

      // If no bundle id, it's not part of a dynamic bundle -> do nothing extra
      if (!bundleId || !itemKey) return;

      // Let Rebuy's own click handler run (no preventDefault / stopPropagation)
      // We just additionally nuke the rest of the bundle
      removeOtherBundleItems(bundleId, itemKey).catch(function (err) {
        console.error("Error removing other bundle items:", err);
      });
    });
  })();